<h1 mat-dialog-title class="heading">Remove {{ itemTag }}</h1>
<div mat-dialog-content>
    <div>
        <h6>Are you sure you want to remove {{ itemTag }} from {{ parentTag }}?</h6>
    </div>
</div>
<div mat-dialog-actions class="buttons">
    <button
        [attr.data-testid]="'cancel_button'"
        class="button-color"
        mat-raised-button
        matTooltip="Cancel"
        (click)="cancelRemoveItem()"
    >Cancel</button>
    <button
        [attr.data-testid]="'ok_button'"
        class="button-color"
        [disabled]="isReadOnly$ | async"
        mat-raised-button
        matTooltip="Save"
        (click)="removeItem()"
    >Ok</button>
</div>
